import React from "react";
import {
  RouteProps as ReactDOMRouteProps,
  Route as ReactDOMRoute,
  Redirect,
} from "react-router-dom";
import { useAuth } from "../contexts/UserContext";

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  component: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  component: Component,
  ...rest
}) => {
  const { user } = useAuth();

    // Rotas temporariamente desativadas que devem redirecionar para demandas
  const disabledRoutes = ['/dashboard', '/financeiro'];

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        // Verifica se a rota atual está na lista de rotas desativadas
        if (disabledRoutes.includes(location.pathname)) {
          return (
            <Redirect
              to={{
                pathname: "/demandas",
                state: { form: location },
              }}
            />
          );
        }

        return isPrivate === !!user ? (
          <Component />
        ) : (
          <Redirect
            to={{
              pathname: isPrivate ? "/login" : "/demandas", // Mudou de "/dashboard" para "/demandas"
              state: { form: location },
            }}
          />
        );
      }}
    />
  );
};

export default Route;